import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseCrudService } from '../../../core/data/services/base-crud.service';
import { OccupationDto } from '../../../core/data/dtos/occupation.dto';

@Injectable({ providedIn: 'root' })
export class OccupationsService extends BaseCrudService<OccupationDto> {
  controller = 'Occupations';

  getOccupations(): Observable<OccupationDto[]> {
    return this.get<OccupationDto[]>();
  }
}
